import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path fill="currentColor" d="m0 6c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v12c0 2.2-1.8 4-4 4h-16c-2.2 0-4-1.8-4-4z" />
    <path
      fill="none"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.8 13.4c0.7 0.6 1.1 1.4 1.1 2.4h-5.7c0-1 0.5-1.8 1.1-2.4"
    />
    <path
      fill="none"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.8 10.1c0 1-0.7 1.9-1.7 1.9-1 0-1.8-0.9-1.8-1.9 0-1.1 0.8-1.9 1.8-1.9 1 0 1.7 0.8 1.7 1.9z"
    />
    <path fill="none" stroke="white" strokeLinecap="round" strokeLinejoin="round" d="m13.8 9.4h6.4" />
    <path fill="none" stroke="white" strokeLinecap="round" strokeLinejoin="round" d="m13.8 12.5h6.4" />
    <path fill="none" stroke="white" strokeLinecap="round" strokeLinejoin="round" d="m13.8 15.6h6.4" />
  </>
);

const Icon = createSvgIcon(svg, 'ContactCardFill');

export default Icon;
